import type { FC, ReactChild, ReactNode } from "react";
import { useState } from "react";

import { BannersContext } from "./BannersContext";

interface Props {
  children: ReactNode;
}

const BannersProvider: FC<Props> = ({ children }) => {
  const [banners, setBanners] = useState<any>([]);
  const [bannersHeight, setBannersHeight] = useState<number>(0);

  const createBanner = (bannerId: string, content: ReactChild) => {
    return setBanners(state => [...state, { key: bannerId, content }]);
  };

  const removeBanner = key => {
    setBanners(state => state.filter(i => i.key !== key));
  };

  return (
    <BannersContext.Provider
      value={{
        banners,
        bannersHeight,
        setBannersHeight,
        createBanner,
        removeBanner,
      }}
    >
      {children}
    </BannersContext.Provider>
  );
};

export { BannersProvider };
